import { render } from "./Carregando.vue?vue&type=template&id=7dafaadc"
import script from "./Carregando.vue?vue&type=script&lang=js"
export * from "./Carregando.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__